<template>
    <BorrarModalComponent
        :name="'deleteEntrada-' + entrada.id"
        title="¿Seguro que quieres borrar esta entrada?"
        borrarTitle="Datos de la entrada"
        confirmButton="¿BORRAR ENTRADA?"
        v-on:close="() => close(false)"
        v-on:confirm="() => borrarEntrada()"
    >
        <ul class="list-group list-group-unbordered mb-3">
            <li class="list-group-item">
                <b>Descripcion:</b> {{ entrada.descripcion }}
            </li>
        </ul>
    </BorrarModalComponent>
</template>

<script>

    import BorrarModalComponent from "@/components/backend/components/BorrarModalComponent";

    export default {
        props: ['evento_id', 'sesion_id', 'entrada'],
        methods: {
            close(borrado) {
                this.$emit('close', 'deleteEntrada-' + this.entrada.id, borrado);
            },
            borrarEntrada() {
                const params = {
                    filters : {},
                    evento_id: this.evento_id,
                    sesion_id: this.sesion_id,
                    entrada_id: this.entrada.id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.tickets.borrar'), params).then(res => {
                    this.$toast.success(res.data.message);
                    this.close(true);
                });
            }
        },
        components: {
            BorrarModalComponent
        }
    }
</script>
